import { Box, Typography, makeStyles } from '@material-ui/core'

import { BASE_COLORS } from 'asterX-UI'

const useStyles = makeStyles(theme => ({
  tooltipContainer: {
    backgroundColor: '#667085',
    padding: '8px 12px',
    borderRadius: 8
  },
  tooltipText: {
    color: BASE_COLORS.White,
    fontSize: 12,
    fontWeight: theme.typography.fontWeightLight
  },
  tooltipValue: {
    fontWeight: theme.typography.fontWeightBold,
    color: BASE_COLORS.White
  }
}))

function CustomTooltip({ active, payload }) {
  const classes = useStyles()

  if (active && payload)
    return (
      <Box className={classes.tooltipContainer}>
        <Typography className={classes.tooltipText}>
          <Typography className={classes.tooltipValue}>
            {payload[1]?.payload.name === 'Мое авто'
              ? 'Мое авто'
              : 'Авто на рынке'}
          </Typography>
          Цена:{' '}
          <span className={classes.tooltipValue}>
            {(payload[1]?.value * 1_000_000).toFixed(0).thousandSeparator()}
          </span>
        </Typography>

        <Typography className={classes.tooltipText}>
          Пробег:{' '}
          <span className={classes.tooltipValue}>
            {(payload[0]?.value * 1000).toFixed(0).thousandSeparator()}
          </span>
        </Typography>
      </Box>
    )

  return null
}

export default CustomTooltip
